import React, { useState, useRef, useMemo } from 'react'

import chevron from '../../assets/icons/icon-select-white.svg'

import './FormRadio.scss'
import { useOnClickOutside } from '../../utils/customHooks'
import { useEffect } from 'react'

/**
 * 
 * @param {Object} props 
 * @param {string=} props.className 
 * @param {string=} props.label 
 * @param {Object[]} props.options 
 * @param {string} props.options.text - The text that is displayed in UI 
 * @param {string} props.options.value - The value that is used for onChange when this option is selected 
 * @param {string=} props.options.group - An optional group for the option 
 * @param {Function} props.onChange - Called with the value of the selected option 
 * @param {Function=} props.onClick
 * @param {string=} props.value - Currently selected option
 * @param {string=} props.emptySelectionText - The text that is displayed when nothing is selected
 * @param {boolean=} props.required
 * @param {boolean=} props.centerContent
 * @param {'normal' | 'big'} [props.size='normal'] props.size
 */
function FormRadio(props) {
  const {
    className = '',
    label,
    options,
    onChange,
    onClick = () => {},
    value,
    emptySelectionText,
    required,
    size="normal"
  } = props

  const [ isFocused, setIsFocused ] = useState(false)

  const ref = useRef()


  let formRadioClassName = `FormRadio ${className} size-${size}`

  if (required && (!value || value === 'none')) {
    formRadioClassName += ' invalid'
  }


  return (
    <div data-testid="FormRadio" className={formRadioClassName} onClick={onClick}>
      {label && <div className="label-container">
        <p className="label">{label} {required && <span className="required">*</span> }</p>
      </div> }
      <div ref={ref} className={`radio-container`}>
        <ul>
          {options.map(item => {          
            return (<li className="radio-item" key={item.value}>
                <input type="radio" id={item.value} value={item.value} name={label} onClick={e => onChange(item.value)}/>
                <label for={item.value}>{item.text}</label>
                <div className="check"></div>
              </li>)}
            )
          }
        </ul>
{/*         <select
          data-testid="select"
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          value={value}
          onChange={(e) => {
            onChange(e.target.value)

            setTimeout(() => {
              // This has to happen after the handleClick of the container,
              // so using setTimeout
              setIsOpen(false)
            }, 0)
          }}
        >
          {rest.map((item, key) => (
            <option key={key} disabled={item.disabled} data-testid="select-option" value={item.value} className={item.className || 'select-option'}>
              {item.text}
            </option>
          ))}
        </select> */}
      </div>
    </div>
  )
}

function OptionGroup(props) {
  const { label, options = [] } = props

  return (
    <optgroup data-testid={label} className="select-option-group" label={label}>
      { options.map(item => {
        return <option className="select-option" key={item.value} value={item.value}>{item.text}</option>
      }) }
    </optgroup>
  )
}

export default FormRadio